import { useEffect } from 'react';

class ScrollLock {
  public static lockCount = 0;

  private static checkLock() {
    if (ScrollLock.lockCount > 0) {
      document.body.classList.add('scroll-lock');

      return;
    }

    document.body.classList.remove('scroll-lock');
  }

  public static lock() {
    ScrollLock.lockCount++;

    ScrollLock.checkLock();
  }

  public static unlock() {
    ScrollLock.lockCount--;

    ScrollLock.checkLock();
  }
}

const useScrollLock = (deps: any[] = []) => {
  useEffect(() => {
    ScrollLock.lock();

    return () => {
      ScrollLock.unlock();
    };
  }, [deps]);
};

export { ScrollLock, useScrollLock };
